import { useState } from 'react';
import Div from '../../common/components/div';
import H1 from '../../common/components/h1';
import translate from '../../common/functions/translate';
import { usePageViewWithSteps } from '../../common/hooks/use.analytics';
import { usePageTitle } from '../../common/hooks/usePageTitle';
import { CreateOrUnlockAccountDataProvider, useCreateOrUnlockAccountData } from '../createAccountContext';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { CreateAccountMaintenance } from './CreateAccountMaintenance';
import YourAccountDetails, { AccountDetailsErrorKeys } from './YourAccountDetails';
import YourBasicInformation, { BasicInformationErrorKeys } from './YourBasicInformation';
import YourMedicareInformation, { MedicareInformationErrorHeaderKeys } from './YourMedicareInformation';

interface CreateAccountProps {
    testInitialErrorState?: MedicareInformationErrorHeaderKeys & BasicInformationErrorKeys & AccountDetailsErrorKeys
}

export default function CreateAccount(props: CreateAccountProps) {
    usePageTitle(translate('create_an_account'));
    const { showMaintenancePageCreateAccount } = useFlags();

    const [step, setStep] = useState(1);
    const { data, updateData } = useCreateOrUnlockAccountData();

    const getStep = () => {
        switch (step) {
            case 1:
                return <YourMedicareInformation />;
            case 2:
                return <YourBasicInformation testInitialErrorState={props.testInitialErrorState} />;
            case 3:
                return <YourAccountDetails testInitialErrorState={props.testInitialErrorState} />;
            default:
                return <YourMedicareInformation/>;
        }
    };

    const getStepTitle = () => {
        switch (step) {
            case 1:
                return 'Your Medicare information';
            case 2:
                return 'Your basic information';
            case 3:
                return 'Your account details';
            default:
                return 'Your Medicare information';
        }
    };

    usePageViewWithSteps('Create an account', step, getStepTitle());

    if(showMaintenancePageCreateAccount) {
        return<CreateAccountMaintenance />
    }
    return <CreateOrUnlockAccountDataProvider value={{
        data,
        updateData,
        stepForward: () => setStep(currentStep => currentStep + 1),
        stepBackward: () => setStep(currentStep => currentStep - 1)
    }}>
        <Div
            isContainer={true}
            paddingySM={1} paddingyMD={2} paddingyLG={3} paddingyXL={4}
        >
            <H1>{translate('create_an_account')}</H1>
            <Div marginTop={3}>
                <p className='ds-text-heading--sm'>
                    {translate('step_of', { step: step, steps: '3'})}
                </p>
            </Div>
            {getStep()}
        </Div>
    </CreateOrUnlockAccountDataProvider>;
}
